import * as React from "react";

import { cn } from "@/lib/utils";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string | null;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, error = false, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex wireless-Regular h-[42px] w-full text-midnightIndigo-400 !m-0 rounded font-regular ring-1 ring-midnightIndigo-200 bg-background px-3 py-2 text-md ring-offset-background file:border-0 file:bg-transparent file:text-sm file:wireless-Medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus:ring-1 focus:border-system-primary  focus:ring-system-primary disabled:cursor-not-allowed disabled:opacity-50",
        "hover:ring-1 hover:ring-midnightIndigo-400 hover:border-0",
        className,
        error && "ring-system-error hover:ring-system-error focus:ring-system-error"
      )}
      ref={ref}
      {...props}
    />
  );
});

Input.displayName = "Input";

export { Input };
